let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1zTvG")).then(() => parcelRequire('g9bZA'));